import React from 'react';
import { Box, Typography } from '@mui/material';

interface QueueCountBadgeProps {
    count: number;
    thresholdLow: number;
    thresholdHigh: number;
    dataTestId?: string;
}

const getBadgeColorToken = (count: number, low: number, high: number): string => {
    if (count >= high) return 'error.dark';
    if (count >= low) return 'warning.dark';
    return 'success.dark';
};

export const QueueCountBadge: React.FC<QueueCountBadgeProps> = ({
    count,
    thresholdLow,
    thresholdHigh,
    dataTestId = 'queue-count-badge',
}) => {
    const displayCount = count > 99 ? '99+' : count.toString();
    const colorToken = getBadgeColorToken(count, thresholdLow, thresholdHigh);

    return (
        <Box
            data-testid={dataTestId}
            aria-label={`${count} transactions`}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: 36,
                height: 36,
                borderRadius: '50%',
                backgroundColor: colorToken,
                px: count > 99 ? 1.5 : 0,
            }}
        >
            <Typography
                sx={{
                    color: 'common.white',
                    fontSize: '0.85rem',
                    fontWeight: 600,
                    lineHeight: 1,
                }}
            >
                {displayCount}
            </Typography>
        </Box>
    );
};